import { useEffect, useState } from 'preact/hooks';
import type { LeaderboardEntry, LeaderboardKind } from '@knight/shared';
import * as S from '../app/state';
import { t } from '../i18n';
import { Btn } from './common';
import { api } from '../net/api';

const KINDS: LeaderboardKind[] = ['fame', 'bestLevel', 'bossKills', 'revenantKills', 'rating', 'guilds'];

export function Leaderboards() {
  const [kind, setKind] = useState<LeaderboardKind>('fame');
  const [rows, setRows] = useState<LeaderboardEntry[]>([]);
  useEffect(() => {
    api.leaderboard(kind).then(setRows).catch(() => setRows([]));
  }, [kind]);
  const me = S.account.value;
  return (
    <div class="screen">
      <div class="card wide panel col tall">
        <div class="row">
          <h2>{t('btn.leaderboards')}</h2>
          <div class="grow" />
          <Btn small onClick={() => (S.screen.value = 'home')}>
            {t('btn.back')}
          </Btn>
        </div>
        <div class="tabs">
          {KINDS.map((k) => (
            <button class={'btn small' + (kind === k ? ' on' : '')} onClick={() => setKind(k)}>
              {t('lb.' + k)}
            </button>
          ))}
        </div>
        <table class="lb">
          <thead>
            <tr>
              <th>{t('label.rank')}</th>
              <th>{t('label.name')}</th>
              <th>{t('lb.' + kind)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr style={{ color: r.id === me?.id ? 'var(--gold)' : undefined }}>
                <td>{r.rank}</td>
                <td>{r.name}</td>
                <td>{r.value}</td>
                <td class="muted small">{r.extra ?? ''}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan={4} class="muted center">
                  {t('label.none')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
